/** @description The key that is used to register the ReportRegistrar with the AppletHost */
export const reportRegistrarKey = 'report-registrar';
